module.exports = __webpack_public_path__ + "lp/img/scaling_cursor_vertical.f68056d6.svg";